import dayjs from "dayjs";

export const NO_EXPIRATION_SENTINEL = "9999-12-31";

export const formatEnrollmentDate = (iso?: string | null): string =>
  iso && !String(iso).startsWith(NO_EXPIRATION_SENTINEL)
    ? dayjs(iso).format("DD/MM/YYYY")
    : "-";

export const formatDate = (date?: string | null): string =>
  date ? dayjs(date).format("DD/MM/YYYY") : "-";
